import { render, staticRenderFns } from "./PieChartWrapper.vue?vue&type=template&id=3618dd18&"
import script from "./PieChartWrapper.vue?vue&type=script&lang=js&"
export * from "./PieChartWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports